import React from 'react';
import { useApi } from '../../../contexts/ApiContext';
import { Button, Modal } from 'semantic-ui-react';
import { useHistory } from 'react-router-dom';
import { OfficialProduct } from './OfficialProduct.type';

type Props = {
  id: number;
  name: OfficialProduct['name'];
  onRequestClose: () => void;
}

export const DeletePrize: React.FC<Props> = ({ id, name, onRequestClose }) => {
  const { callApi } = useApi();
  const history = useHistory();

  return (
    <Modal open onClose={onRequestClose} size="mini" >
      <Modal.Header>Delete official product</Modal.Header>
      <Modal.Content>{`Are you sure to delete ${name}`}</Modal.Content>
      <Modal.Actions>
        <Button
          negative
          onClick={() => callApi.delete(`/officialProduct/${id}`).then(() => {
            onRequestClose();
            history.go(0);
          })}>Delete</Button>
        <Button onClick={onRequestClose}>Cancel</Button>
      </Modal.Actions>
    </Modal>
  );
}